<form class="search-form rounded" [formGroup]="filterModel" (ngSubmit)="doFilter()">
  <input
    id="filter-text"
    type="search"
    name="filterText"
    placeholder="Filter..."
    formControlName="filterText"
    (ngModelChange)="doFilter()"
  />
  @if (filterIsActive) {
    <button type="reset" (click)="reset()">
      <svg lucideX></svg>
    </button>
  } @else {
    <button type="submit"><svg lucideFunnel></svg></button>
  }
</form>
